import { Component, OnInit, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { PatientService } from '../services/patient.service';

@Component({
  selector: 'app-patientsearch',
  templateUrl: './patientsearch.component.html',
  styleUrls: ['./patientsearch.component.css']
})

export class PatientSearchComponent implements OnInit {

  public showTitle = true;
  public noresults = false;

  constructor(private patientService : PatientService, private router : Router) { ;  }

  ngOnInit() { 
    sessionStorage.removeItem('myPatients');
    sessionStorage.removeItem('myTestOrders');
    
    if (this.router.url == "/reporting/mypatients")
      this.showTitle = false;
   }

  OnSubmit(patientLastName, patientDOB, patientSSN)
  {
    this.patientService.getMyPatients(patientLastName, patientDOB, patientSSN).subscribe(
        (data : any)=>{
          if (data.length > 0)
          {
            sessionStorage.setItem('myPatients',JSON.stringify(data));
            this.router.navigate(['/reporting/mypatients']);
          }
          else
          {
            this.noresults = true;
          }
        },
        (err : HttpErrorResponse)=>{
          console.log(err);
        }
      );
  }
}
